/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kristian Godinez",
  title: "Hi all, I'm Kristian, otherwise known as DeniedPath",
  subTitle: emoji(
    "A curious Full Stack Developer 🧩 passionate about building thoughtful and creative web experiences using Next.js, TypeScript, and MongoDB. I enjoy blending AI, cybersecurity, and interactive design—crafting both useful tools and fun experiments. Always exploring new libraries, frameworks, and ideas to learn something new (and share it when I can)."
  ),
  resumeLink:
    "https://docs.google.com/document/d/1zqj7UdoMU9kqkXAVkL-SIvI5zFekLLECoVbhXjexyr8/edit?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/DeniedPath",
  linkedin: "https://www.linkedin.com/in/kristiangodinez/",
  gmail: "deniedpathdev@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Full Stack Developer exploring AI, UI/UX, and real-world problem solving",
  skills: [
    emoji("⚡ Build responsive and dynamic web apps using Next.js, React, and TypeScript"),
    emoji("⚡ Create intelligent tools using Python, AI APIs like OpenAI, and LangChain"),
    emoji("⚡ Design clean, user-focused UI/UX with Tailwind, Bootstrap, and CSS3"),
    emoji("⚡ Integrate cloud services like Firebase and AWS into full-stack projects"),
    emoji("⚡ Focus on real-world solutions—from internal dashboards to chatbot experiences")
  ],
  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */
  softwareSkills: [ 
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "SASS",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "fas fa-wind"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fas fa-layer-group"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Express.js",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "MySQL / SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "EJS",
      fontAwesomeClassname: "fas fa-code"
    }
  ],
  display: true,
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Arizona State University",
      logo: require("./assets/images/asuLogo.png"), // Replace with your ASU logo file
      subHeader: "Business Technology Fundamentals, Computer Networking, and OS Management",
      duration: "2023 - Present",
      desc: "Studying foundational and technical topics for business systems and IT management.",
      descBullets: [
        "Completed coursework in Business Technology Fundamentals (2023)",
        "Studied Computer Networking in Organizations (2024)",
        "Currently learning Operating Systems Management for Business"
      ]
    },
    {
      schoolName: "Jules E. Mastbaum AVTS",
      logo: require("./assets/images/mastbaumLogo.png"), // Replace with your high school logo file
      subHeader: "High School Diploma - Major in Sports Marketing",
      duration: "2019 - 2023",
      desc: "Graduated with a focus on marketing principles and technology.",
      descBullets: ["Graduated in 2023"]
    }
  ]
};


// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, // Set it to true to show workExperiences section
  experience: [
    {
      role: "LiftOff Associate",
      company: "Launchpad",
      companylogo: require("./assets/images/launchpadLogo.png"), // Add this logo file
      date: "August 2024 – Present",
      desc: "Designed and developed multiple AI-powered applications to solve real business problems.",
      descBullets: [
        "Built projects using OpenAI, Hugging Face, and LangChain",
        "Collaborated with teams using Agile and multi-language development",
        "Showcased applications at tech events and explored partnership opportunities"
      ]
    },
    {
      role: "UI/UX Designer",
      company: "Building 21 Philadelphia",
      companylogo: require("./assets/images/building21Logo.png"), // Add or create this logo
      date: "July 2024",
      desc: "Redesigned the high school’s official website and contributed to SEO optimization for Launchpad."
    },
    {
      role: "Chromebook Repair Technician",
      company: "Work Ready / School District of Philadelphia",
      companylogo: require("./assets/images/workreadyLogo.png"), // Optional logo
      date: "June 2022",
      desc: "Repaired over 50 Chromebooks and developed strong hands-on skills with hardware troubleshooting."
    },
    {
      role: "Launchpad Student",
      company: "Launchpad",
      companylogo: require("./assets/images/launchpadLogo.png"),
      date: "January 2023 – August 2024",
      desc: "Completed intensive training in software development and tech industry skills.",
      descBullets: [
        "Completed 200+ hours of Python training, including web APIs and real-world projects",
        "Built games, animations, and tools using Python and debugging techniques",
        "Led a tech presentation for over 30 students and designed a solution to a local issue"
      ]
    }
  ]
};


/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Projects I'm passionate about and actively building",
  projects: [
    {
      image: require("./assets/images/cosmoChronLogo.png"), // Add your own CosmoChron logo or image
      projectName: "CosmoChron",
      projectDesc:
        "CosmoChron is an AI-powered celestial-themed productivity app that helps users manage their time effectively through immersive space backgrounds, achievement systems, productivity tracking, and interactive features including a personalized AI companion.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://cosmo-chron.vercel.app"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆"),
  subtitle:
    "Some certifications and milestones I’ve accomplished along my developer journey.",

  achievementsCards: [
    {
      title: "PCEP Certified Entry-Level Python Programmer",
      subtitle:
        "Earned the PCEP-30-02 certification from the Python Institute in 2024, demonstrating foundational Python programming skills.",
      image: require("./assets/images/pythonLogo.png"), // Replace with your own image if needed
      imageAlt: "Python Certification Logo",
      footerLink: [
        {
          name: "Python Institute",
          url: "https://pythoninstitute.org/certification/pcep-certification-entry-level"
        }
      ]
    },
    {
      title: "Tech Presenter & Peer Educator",
      subtitle:
        "Presented to over 30 middle school students about careers in tech, sharing my learning path and inspiring future developers.",
      image: require("./assets/images/presentationIcon.png"), // Optional image
      imageAlt: "Presentation Icon",
      footerLink: []
    },
    {
      title: "AI-Powered Applications Developer",
      subtitle:
        "Created over 4 custom applications using OpenAI, LangChain, and Hugging Face to solve real-world business problems through Launchpad.",
      image: require("./assets/images/aiLogo.png"), // Optional AI or custom project icon
      imageAlt: "AI Project Icon",
      footerLink: [
        {
          name: "CosmoChron Project",
          url: "https://cosmo-chron.vercel.app"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 (260) 619-1405", // Your phone number
  email_address: "deniedpathdev@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
